import script from "./ConferenceModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConferenceModal.vue?vue&type=script&setup=true&lang=js"

import "./ConferenceModal.vue?vue&type=style&index=0&id=229bbe8e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-229bbe8e"]])

export default __exports__